var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-scroll",class:{
        'base-scroll__no-bars' : _vm.noBars,
        'base-scroll__has-border' : _vm.hasBorder
    },style:(("height: " + _vm.height + ";"))},[_c('div',{staticClass:"base-scroll__content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }